import { ReferenceDateType } from "../../../../../../api/types/dashboardsTypes";

export const allReferenceDateTypes = [
  ReferenceDateType.ThisMonth,
  ReferenceDateType.ThisQuarter,
  ReferenceDateType.ThisYear,
  ReferenceDateType.LastMonth,
  ReferenceDateType.LastQuarter,
  ReferenceDateType.LastYear,
  ReferenceDateType.Last7Days,
  ReferenceDateType.Last30Days,
  ReferenceDateType.Last12Months,
  ReferenceDateType.CustomRange,
];

export const currentPeriodDateTypes = [
  ReferenceDateType.ThisMonth,
  ReferenceDateType.ThisQuarter,
  ReferenceDateType.ThisYear,
];

export const lastPeriodDateTypes = [
  ReferenceDateType.LastMonth,
  ReferenceDateType.LastQuarter,
  ReferenceDateType.LastYear,
  ReferenceDateType.Last7Days,
  ReferenceDateType.Last30Days,
  ReferenceDateType.Last12Months,
];

export const referenceDateOptions = [
  {
    label: "This Month",
    value: ReferenceDateType.ThisMonth,
  },
  {
    label: "This Quarter",
    value: ReferenceDateType.ThisQuarter,
  },
  {
    label: "This Year",
    value: ReferenceDateType.ThisYear,
  },
  {
    label: "Last Month",
    value: ReferenceDateType.LastMonth,
  },
  {
    label: "Last Quarter",
    value: ReferenceDateType.LastQuarter,
  },
  {
    label: "Last Year",
    value: ReferenceDateType.LastYear,
  },
  {
    label: "Last 7 Days",
    value: ReferenceDateType.Last7Days,
  },
  {
    label: "Last 30 Days",
    value: ReferenceDateType.Last30Days,
  },
  {
    label: "Last 12 Months",
    value: ReferenceDateType.Last12Months,
  },
  {
    label: "Custom Range",
    value: ReferenceDateType.CustomRange,
  },
];

export const getReferenceDateLabel = (type: ReferenceDateType): string => {
  return referenceDateOptions.find((option) => option.value === type)?.label ?? type;
};
